import { render, staticRenderFns } from "./SpecialtyProfileComponent.vue?vue&type=template&id=306cf739&scoped=true"
import script from "./SpecialtyProfileComponent.vue?vue&type=script&lang=js"
export * from "./SpecialtyProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./SpecialtyProfileComponent.vue?vue&type=style&index=0&id=306cf739&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306cf739",
  null
  
)

export default component.exports